import { Form, FormikFormProps } from "formik";
import React from "react";

export class FormikForm extends React.PureComponent<FormikFormProps> {
  static defaultProps: Partial<FormikFormProps> = {
    autoComplete: "off",
    noValidate: true,
  };

  render() {
    return <Form {...this.props} />;
  }
}
